"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.download = void 0;

var _env = require("../env");

require("url-search-params-polyfill");

/**
 * @file 下载模块，自动根据环境下载 App
 * @author qiaogang
 * @date 2020-05-09
 */
// Apple 商店
var iOSUrl = 'https://apps.apple.com/cn/app/id1279715325'; // 安卓默认安装包，无渠道标识

var androidUrl = 'https://coolcdn.igetcool.com/client/android/apk/app-igetcool-release.apk'; // 腾讯应用宝

var wxUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.dedao.juvenile';
var urlSearch = new URLSearchParams(location.search);
/**
 * 下载 App
 * 会根据页面中 query 值指定不同的下载包，如果不指定，会使用通用安装包
 * query 规则如下：
 * ios_url = iOS 安装地址，默认指定 AppleStore 的下载地址
 * android_url = 安卓默认指定无渠道下载包
 * dl_auto_jump = 是否自动下载，默认关闭
 */

var download = {
  _created: function _created() {
    var ios = urlSearch.get('ios_url');
    var android = urlSearch.get('android_url');

    if (ios) {
      iOSUrl = ios;
    }

    if (android) {
      androidUrl = android;
    } // 微信环境


    if (_env.env.isWeChat) {
      androidUrl = wxUrl;
    }
  },

  /**
   * 初始化，判断是否有自动跳转
   */
  init: function init() {
    this._created(); // 自动跳下载


    var autoJump = urlSearch.get('dl_auto_jump');

    if (autoJump) {
      this.launch();
    }
  },

  /**
   * 触发跳转下载
   */
  launch: function launch() {
    this._created();

    location.href = _env.env.isIOS ? iOSUrl : androidUrl;
  }
};
exports.download = download;